import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960,1807.05882 C492.875294,1807.05882 112.941176,1427.12471 112.941176,960 C112.941176,492.875294 492.875294,112.941176 960,112.941176 C1427.12471,112.941176 1807.05882,492.875294 1807.05882,960 C1807.05882,1427.12471 1427.12471,1807.05882 960,1807.05882 M960,0 C430.644706,0 0,430.644706 0,960 C0,1489.35529 430.644706,1920 960,1920 C1489.35529,1920 1920,1489.35529 1920,960 C1920,430.644706 1489.35529,0 960,0 M1129.41176,1047.90212 C1129.41176,1155.08329 1042.22118,1242.38682 934.927059,1242.38682 L872.131765,1242.38682 C764.837647,1242.38682 677.647059,1155.08329 677.647059,1047.90212 L677.647059,872.052706 C677.647059,764.871529 764.837647,677.680941 872.131765,677.680941 L934.927059,677.680941 C1042.22118,677.680941 1129.41176,764.871529 1129.41176,872.052706 L1129.41176,1047.90212 Z M960,567.224471 C951.642353,566.546824 943.510588,564.739765 934.927059,564.739765 L872.131765,564.739765 C702.607059,564.739765 564.705882,702.528 564.705882,872.052706 L564.705882,1047.90212 C564.705882,1217.42682 702.607059,1355.328 872.131765,1355.328 L934.927059,1355.328 C1104.45176,1355.328 1242.35294,1217.42682 1242.35294,1047.90212 L1242.35294,872.052706 C1242.35294,797.963294 1214.90824,730.763294 1171.08706,677.680941 L1411.76471,677.680941 L1411.76471,564.739765 L960,564.739765 L960,567.224471 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconQuizStatsDeviationLine = /*#__PURE__*/function (_Component) {
  _inherits(IconQuizStatsDeviationLine, _Component);

  var _super = _createSuper(IconQuizStatsDeviationLine);

  function IconQuizStatsDeviationLine() {
    _classCallCheck(this, IconQuizStatsDeviationLine);

    return _super.apply(this, arguments);
  }

  _createClass(IconQuizStatsDeviationLine, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconQuizStatsDeviation",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconQuizStatsDeviationLine.displayName = "IconQuizStatsDeviationLine";
  return IconQuizStatsDeviationLine;
}(Component);

IconQuizStatsDeviationLine.glyphName = 'quiz-stats-deviation';
IconQuizStatsDeviationLine.variant = 'Line';
IconQuizStatsDeviationLine.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconQuizStatsDeviationLine;
export { IconQuizStatsDeviationLine };